export const settings = await import(
  `./landing/themes/${process.env.REACT_APP_TYPE}/settings.json`
)
